<script>
import throttle from 'lodash/throttle';
import { Collapse } from 'vue-collapsed';
import Modal from '@/components/modules/Modal.vue';

export default {
    name: 'Header',
    data: () => ({
        scrollY: 0,
        scrollDir: 'down',
        scrollThreshold: 100, // below this px, header is "scrolled"
        isSearchOpen: false,
        isInitialized: false,
        mobileNavOpenSubnav: null
    }),
    mounted () {
        this.isInitialized = true;
        this.updateScroll();
        window.addEventListener('scroll', this.scroll);
    },
    beforeUnmount () {
        window.removeEventListener('scroll', this.scroll);
    },
    methods: {
        toggleSearch () {
            this.isSearchOpen = !this.isSearchOpen;
        },
        toggleSubnav (ref) {
            const subnav = this.$refs[`subnav-${ref}`];
            const trigger = this.$refs[`trigger-${ref}`];

            if (subnav.style.display === 'none') {
                subnav.style.display = 'block';
                trigger.classList.add('state-active');
            } else {
                subnav.style.display = 'none';
                trigger.classList.remove('state-active');
            }
        },

        openMobilenav () {
            this.$refs.mobilenav.openModal();
        },
        setMobileNavOpenSubnav (index, e) {
            if (this.mobileNavOpenSubnav === index) {
                this.mobileNavOpenSubnav = null;
            } else {
                this.mobileNavOpenSubnav = index;
            }
        },

        updateScroll () {
            this.rafIsTicking = false;

            const { scrollY } = this;
            const newScrollY = window.pageYOffset || document.documentElement.scrollTop;

            if (newScrollY !== scrollY) {
                const root = document.documentElement;
                const scrollDir = newScrollY >= scrollY ? 'down' : 'up';

                this.scrollDir = scrollDir
                this.scrollY = newScrollY;

                root.classList.toggle('header-is-scrolled', newScrollY > this.scrollThreshold);
                root.classList.toggle('header-is-scrolling-up', scrollDir === 'up');
            }
        },
        scroll: throttle(function () {
            if (!this.rafIsTicking) {
                window.requestAnimationFrame(this.updateScroll);
            }
            this.rafIsTicking = true;
        }, 200, { leading: true }, true),
    },
    components: {
        Collapse,
        Modal
    }
};
</script>